import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiCompanies {
  static getCompanies() {
    return apiFetch(`${ApiBaseUrl}companies`);
  }

  static createCompany(companyName, awsMarketplaceCustomerId, awsMarketplaceEnabled) {
    return apiFetch(`${ApiBaseUrl}companies`, {
      method: "POST",
      body: {
        company: {
          name: companyName,
          aws_marketplace_customer_id: awsMarketplaceCustomerId,
          aws_marketplace_enabled: awsMarketplaceEnabled,
        },
      },
    });
  }
}
